export const DrawerDareMainInfo = ({ title, description }) => (
  <div className="flex flex-col gap-y-2 sm:gap-y-4">
    <h1 className="font-hk sm:text-lg font-bold text-dashboardtext">{title}</h1>
    <h1 className="font-hk text-sm text-dashboardalttext">{description}</h1>
  </div>
)
